export default __webpack_public_path__ + "static/media/lns-logotext-white.02e94188.svg";